import { useMutation } from "react-query";
import { refreshToken } from "./api/auth";
import { useSetRecoilState } from "recoil";
import { authAtom } from "./recoil/atoms";
import jwtDecode from "jwt-decode";
import client from "./api/client";

export const useRefresh = () => {
  const setAuthAtom = useSetRecoilState(authAtom);
  const onError = ({
    response: {
      status,
      data: { code },
    },
  }) => {
    if (status === 401 && code === "INVALID_REFRESH_TOKEN") {
      setAuthAtom({
        isLoggedIn: false,
        username: null,
        name: null,
      });
    }
  };
  const onSuccess = ({ data: { accessToken } }) => {
    setAuthAtom({
      isLoggedIn: true,
      username: jwtDecode(accessToken).user.username,
      name: jwtDecode(accessToken).user.name,
    });

    client.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
  };
  return useMutation(refreshToken, { onError, onSuccess });
};
